import React, { useEffect } from 'react';
import MostBookedChart from './MostBookedChart';
import BookingHistoryChart from './BookingHistoryChart';
import Card from '../../../../muiComponents/Card';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import {
    cardsGridSpacing,
    chartCardChildGrid,
} from '../../../../utils/dashboard/dashbordUtils';
import {
    useDashboard,
    useHistoryBookings,
    useHotelsBooked,
} from '../../../../contexts/DashboardContext';

const DashboardCharts = () => {
    const { getChartsInitialData } = useDashboard();
    const { isDataLoaded: isDataLoadedHotelsBooked } = useHotelsBooked();
    const { isDataLoaded: isDataLoadedBookingHistory } = useHistoryBookings();

    useEffect(() => {
        if (!isDataLoadedHotelsBooked || !isDataLoadedBookingHistory) {
            getChartsInitialData();
        }
    }, []);

    return (
        <Grid
            className='margin-0 flex-grow'
            columnSpacing={cardsGridSpacing}
            rowSpacing={cardsGridSpacing}
        >
            <GridChild gridProps={chartCardChildGrid}>
                <Card
                    className='padding20 flex-column gap-20 height100perc'
                    style={{ maxHeight: '400px' }}
                >
                    <MostBookedChart />
                </Card>
            </GridChild>
            <GridChild gridProps={chartCardChildGrid}>
                <Card
                    className='padding20 flex-column gap-20 height100perc'
                    style={{ maxHeight: '400px' }}
                >
                    <BookingHistoryChart />
                </Card>
            </GridChild>
        </Grid>
    );
};

export default DashboardCharts;
